export enum LogLevel {
  NONE = 0,
  ERROR = 1,
  WARN = 2,
  INFO = 3,
  DEBUG = 4,
}

class LoggerService {
  private static instance: LoggerService;
  private logLevel: LogLevel = LogLevel.INFO; // Erhöhen für mehr Logging

  private constructor() {}

  static getInstance(): LoggerService {
    if (!LoggerService.instance) {
      LoggerService.instance = new LoggerService();
    }
    return LoggerService.instance;
  }

  setLogLevel(level: LogLevel) {
    this.logLevel = level;
  }

  // ✅ NEU: Hilfsmethode für Zeitstempel
  private formatMessage(prefix: string, message: string): string {
    const timestamp = new Date().toISOString().split('T')[1].slice(0, -1);
    return `${prefix} [${timestamp}] ${message}`;
  }

  error(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.ERROR && process.env.NODE_ENV !== 'production') {
      console.log(this.formatMessage('❌', message), ...args);
    }
  }

  warn(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.WARN && process.env.NODE_ENV !== 'production') {
      console.log(this.formatMessage('⚠️', message), ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.INFO && process.env.NODE_ENV !== 'production') {
      console.log(this.formatMessage('ℹ️', message), ...args);
    }
  }

  debug(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.DEBUG && process.env.NODE_ENV !== 'production') {
      console.log(this.formatMessage('🔍', message), ...args);
    }
  }

  // ✅ NEU: Spezielle Methoden für bessere Kategorisierung
  success(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.INFO) {
      console.log(this.formatMessage('✅', message), ...args);
    }
  }

  performance(message: string, timeMs: number, ...args: any[]) {
    if (this.logLevel >= LogLevel.DEBUG) {
      console.log(this.formatMessage('⏱️', `${message} (${timeMs.toFixed(2)}ms)`), ...args);
    }
  }

  network(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.DEBUG) {
      // console.debug(this.formatMessage('🌐', message), ...args);
    }
  }

  database(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.DEBUG) {
      // console.debug(this.formatMessage('🗄️', message), ...args);
    }
  }

  score(message: string, ...args: any[]) {
    if (this.logLevel >= LogLevel.INFO) {
      // console.info(this.formatMessage('🎯', message), ...args);
    }
  }
}

export const logger = LoggerService.getInstance();
